import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, Typography, Grid, Box } from "@mui/material";

import { useAxios } from "../../hooks";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    background: "transparent",
    width: "calc(100% - 15px)",
    margin: "15px",
  },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  textAlign: "start",
  alignContent: "center",
  alignItems: "center",
  borderRadius: "12.5px",
  background: "rgb(255, 255, 255)",
  padding: "25px",
  width: "100%",
}));

const BadgeDetails = ({ campusID, badgeViewPopup, setBadgeViewPopup }) => {
  const axios = useAxios();

  const [badgeList, setBadgeList] = useState([]);

  useEffect(() => {
    if (campusID) {
      axios({
        url: `attendance/campus/get-campus-badges?campus_id=${campusID}`,
      }).then((response) => {
        if (response.status) {
          setBadgeList(response.data);
        }
      });
    }
  }, [campusID]);

  return (
    <StyledDialog
      open={badgeViewPopup}
      onClose={() => setBadgeViewPopup(false)}
      maxWidth="sm"
      fullWidth
    >
      <Grid container sx={{ background: "transparent", padding: "10px 0px" }}>
        <Grid item container justifyContent={"end"}>
          <CloseIcon
            sx={{
              fontSize: "35px",
              padding: "4px",
              color: "white",
              borderRadius: "50%",
              background: "#FFFFFF38",
            }}
            onClick={() => setBadgeViewPopup(false)}
          />
        </Grid>
      </Grid>

      <DialogContent sx={{ padding: "5px 0px" }}>
        <ContentBox>
          <Typography
            variant="h6"
            fontWeight={700}
            textAlign={"center"}
            sx={{
              "-webkit-text-stroke-width": "0.1px",
              fontSize: "20px",
              marginBottom: "5px",
            }}
          >
            Badge Access
          </Typography>

          <Grid container direction="column" alignItems="left">
            {badgeList.map((item, indx) => {
              return (
                <Grid item container mt={3}>
                  <Typography
                    variant="h6"
                    fontWeight={400}
                    textAlign={"left"}
                    sx={{
                      fontSize: "12px",
                      color: "#111111CC",
                      margin: "0px",
                      background: `${item.color}`,
                      padding: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    {item.badge_name}
                  </Typography>
                  {item.zone_name.map((item, index) => {
                    return (
                      <Typography
                        variant="body1"
                        fontWeight={400}
                        ml={2}
                        mr={2}
                        sx={{ alignContent: "center" }}
                      >
                        {index + 1}. {item}
                      </Typography>
                    );
                  })}
                </Grid>
              );
            })}
          </Grid>
        </ContentBox>
      </DialogContent>
    </StyledDialog>
  );
};

export default BadgeDetails;
